export default function areEqual(
  firstString: string,
  secondString: string
): boolean {
  return firstString === secondString;
}
